import React, { useEffect, useState } from 'react';
import './nav-buttons.scss';
import { isReadOnlyPreviewEnabled } from '../../../utils/readOnlyPreview';

function NavButtons(props) {
  const readOnlyPreview = isReadOnlyPreviewEnabled();
  const [allowContinue, setAllowContinue] = useState(readOnlyPreview);

  useEffect(() => {
    if (readOnlyPreview) {
      setAllowContinue(true);
      return;
    }

    let timeout = setTimeout(() => {
      setAllowContinue(true);
    }, Number(process.env.REACT_APP_SECONDS));

    return () => {
      clearTimeout(timeout);
    };
  }, [readOnlyPreview]);
  const handleScroll = () => {
    const bottom =
      Math.ceil(window.innerHeight + window.scrollY) >=
      document.documentElement.scrollHeight - 50;
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true,
    });
    if (
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 50
    ) {
    } else {
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [props.size]);

  return (
    <>
      <div className='nav-button-wrap'>
        <div className='button-box'>
          <button onClick={() => props.handleProgress(false)}>Back</button>
          <button
            className={allowContinue ? 'enable' : 'disable'}
            style={{ pointerEvents: !allowContinue ? 'none' : '' }}
            onClick={() => {
              setAllowContinue(false);
              if (allowContinue) {
                props.handleProgress(true);
              }
            }}
            {...(props.submitID && { type: 'submit', form: props.submitID })}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
}

export default NavButtons;
